// import {} from '../actions/multishareActions.js';
import initialState from './initialState.js';
import _ from 'lodash'



export default function multishareReducer(state = initialState.multishare, action) {

  switch (action.type) {
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/multishareReducer.js